export const MAX_VISIBLE_CHECKS = 3;
